/* --- Fork of librairy made by justgoscha and licensed under MIT license --- */
import angular from 'angular'

/* @ngInject */
const myInput = (
  valueHandler,
  labels,
  types,
  $$setting,
  optionsHandler,
) => {
  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      myOptions: '=',
      myDisabled: '=?',
      enableValidator: '=?',
      enableSearch: '=?',
      mySearchNull: '=?',
      mySearchOperator: '=?',
      suggestions: '=autocomplete',
      change: '&fnChange',
      fnwatch: '&fnWatch',
    },
    template: require('./myInput.html'),

    /* @ngInject */
    controller: ($scope, ) => {
      $scope.advancedSearch = $$setting.data.general.checkboxs.advancedSearch

      $scope.selectedIndex = -1
      $scope.completing = false
      $scope.searchFilter = ''

      $scope.setIndex = (i) => {
        $scope.selectedIndex = parseInt(i)
      }

      $scope.getIndex = () => {
        return $scope.selectedIndex
      }

      $scope.$watch('ngModel', (newValue, oldValue) => {
        if (oldValue === newValue) { return }
        if (newValue !== $scope.searchFilter) {
          $scope.searchFilter = newValue ? newValue.toString().trim() : ''
          $scope.selectedIndex = -1
        } else {
          $scope.completing = false
        }
      })

      $scope.preSelect = (index) => {
        $scope.selectedIndex = parseInt(index)
      }

      $scope.preSelectOff = () => {
        $scope.selectedIndex = -1
      }

      $scope.select = (suggestion) => {
        if (suggestion) {
          $scope.ngModel = suggestion
          $scope.searchFilter = ''
        }
        $scope.completing = false
        $scope.setIndex(-1)
      }

      $scope.onBlur = () => {
        $scope.completing = false
      }

      $scope.onFocus = () => {
        $scope.completing = true
      }

      $scope.onType = () => {
        $scope.completing = true
      }

      // setTimeout(() => $scope.$apply())
    },
    link: {
      pre: (scope, element, attrs, ngModel) => {
        const defaultOptions = {
          icon: '',
          label: '',
          ref: '',
          required: false,
          disabled: scope.myDisabled || false,
          type: types.text(),
          unique: false,
          messages: {
            required: labels.error.input.required,
            exists: labels.error.input.exists,
          },
        }

        const options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)

        scope.id = options.ref
        scope.type = options.type
        scope.displayNullRadio = !options.required
        scope.messages = options.messages

        scope.mySearchNull = 'any'
        scope.mySearchOperator = '='

        scope.$watch('mySearchNull', (newValue, oldValue) => {
          if (newValue !== oldValue && valueHandler.isNull(newValue)) {
            scope.mySearchNull = 'any'
          }
        })

        scope.$watch('mySearchOperator', (newValue, oldValue) => {
          if (newValue !== oldValue && valueHandler.isNull(newValue)) {
            scope.mySearchOperator = '='
          }
        })
      },
      post: (scope, element, attrs, ngModel) => {
        let timer = null
        const disapearTime = $$setting.data.general.sliders.autocompleteTimer.model * 1000

        element.bind('mouseleave', () => {
          if (disapearTime > 0) {
            timer = setTimeout(() => {
              scope.completing = false
              scope.$apply()
            }, disapearTime)
          } else {
            scope.completing = false
            scope.$apply()
          }
        })

        element.bind('mouseenter', () => {
          if (timer)
            clearTimeout(timer)
        })

        const key = {
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          enter: 13,
          esc: 27,
          tab: 9,
        }

        const keyDownHander = (e) => {
          var keycode = e.keyCode || e.which

          var lng = element.find('li').length

          let index
          switch (keycode) {
            case key.up:
              index = scope.selectedIndex - 1
              if (index < 0) {
                index = lng - 1
              }
              scope.setIndex(index)
              break
            case key.down:
              index = scope.selectedIndex + 1
              if (index >= lng) {
                index = 0
              }
              scope.setIndex(index)
              break
            case key.left:
              break
            case key.right:
            case key.enter:
            case key.tab:
              index = scope.getIndex()
              if (index === -1) {
                scope.completing = false
                break
              }

              scope.select(angular.element(element.find('li')[index]).text())
              scope.setIndex(-1)
              scope.completing = false
              break
            case key.esc:
              // disable suggestions on escape
              scope.select()
              scope.setIndex(-1)
              scope.$apply()
              e.preventDefault()
              break
            default:
          }

          scope.$apply()
        }

        element[0].addEventListener('keydown', keyDownHander)

        scope.$on('$destroy', () => {
          element.off()
          element[0].onclick = null
          element[0].removeEventListener('keydown', keyDownHander)
        })

      },
    },
  }
}

export default myInput



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myInput.js